import { Validator } from 'vee-validate'
import phoneValidator from '@/validators/phone'
import streetValidator from '@/validators/street'
import companyValidator from '@/validators/company'
import zipCodeValidator from '@/validators/zipCode'
import personValidator from '@/validators/person'
import cityValidator from '@/validators/city'
import mustStartEndLetterValidator from '@/validators/mustStartEndLetter'
import mustStartEndLetterNumberValidator from '@/validators/mustStartEndLetterNumber'

class ProductShippingValidator {
  create () {
    Validator.extend('company', companyValidator)

    Validator.extend('phone_number', phoneValidator, {
      computesRequired: true
    })

    Validator.extend('person_name', personValidator, {
      computesRequired: true
    })

    Validator.extend('city', cityValidator, {
      computesRequired: true
    })

    Validator.extend('street', streetValidator, {
      computesRequired: true
    })

    Validator.extend('street2', streetValidator)

    Validator.extend('zip_code', zipCodeValidator, {
      computesRequired: true
    })

    Validator.extend('mustStartEndLetter', mustStartEndLetterValidator, {
      computesRequired: true
    })

    Validator.extend('mustStartEndLetterNumber', mustStartEndLetterNumberValidator, {
      computesRequired: true
    })
  }
}

export default ProductShippingValidator
